import { getEmbedUrl } from "../lib/utils"

const YTEmbed = (props) => {
  const embedUrl = getEmbedUrl(props.text);

  return (
    embedUrl && <iframe
      src={embedUrl}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="YouTube Video"
    ></iframe>
  )
}

export default YTEmbed;
